module.exports = __webpack_public_path__ + "img/publicity.f0ce9b5a.png";